import { createRequestHelper } from '../../common';
export const createClaimRequest = createRequestHelper();
